import QueryList from "./queryList.gql";
import {queryHdl, mutationHdl} from "../graphqlHdr";

export default {
  // 查询签到记录
  queryList: (vueSelf, variables) => queryHdl.call(vueSelf, QueryList, variables),
}
